// extracted by mini-css-extract-plugin
export var text = "_p-0";